"use client";

import { motion } from "framer-motion";
import Navbar from "@/app/components/Navbar";
import Footer from "@/app/components/Footer";

export default function ChangelogPage() {
  return (
    <>
      <Navbar />
      <main className="min-h-screen px-6 py-32 flex items-center" style={{ background: "#0A0908" }}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl mx-auto w-full text-center"
        >
          <p
            className="text-xs tracking-[0.3em] uppercase mb-3"
            style={{ color: "rgba(201,168,76,0.7)", fontFamily: "'Montserrat', sans-serif" }}
          >
            Changelog
          </p>
          <h1
            className="text-4xl md:text-5xl font-light leading-tight mb-6"
            style={{ color: "#F5F0E8", fontFamily: "'Cormorant', serif" }}
          >
            We're{" "}
            <span style={{ color: "#C9A84C", fontStyle: "italic" }}>just launching</span>
          </h1>
          <p
            className="text-sm leading-relaxed mb-12 max-w-md mx-auto"
            style={{ color: "rgba(245,240,232,0.45)", fontFamily: "'Montserrat', sans-serif" }}
          >
            Aurelius &amp; Co is in early launch. Every feature shipped, every improvement made, and every fix deployed will be documented here — in real time, no marketing fluff.
          </p>

          <div className="p-10" style={{ border: "1px solid rgba(201,168,76,0.12)" }}>
            <div
              className="text-4xl mb-4"
              style={{ color: "rgba(201,168,76,0.4)", fontFamily: "'Cormorant', serif" }}
            >
              ✦
            </div>
            <p
              className="text-xs tracking-widest uppercase mb-2"
              style={{ color: "#C9A84C", fontFamily: "'Montserrat', sans-serif" }}
            >
              First entries coming soon
            </p>
            <p
              className="text-xs leading-relaxed max-w-xs mx-auto"
              style={{ color: "rgba(245,240,232,0.25)", fontFamily: "'Montserrat', sans-serif" }}
            >
              Subscribe to our newsletter to be notified when new updates ship.
            </p>
          </div>
        </motion.div>
      </main>
      <Footer />
    </>
  );
}
